// Import Actions
import { SET_SUBJECTS } from './SubjectActions';
import { SET_PAGES } from '../Page/PageActions';
import { SET_QUESTIONS } from '../Question/QuestionActions';
import { LOGOUT_USER } from '../User/AuthActions';
import { SET_IS_FETCHING } from '../App/AppActions';

// Initial State
export const initialState = {
    data: [],
    isFetching: false,
};

// Think to update reducers.js

const SubjectReducer = (state = initialState, action = {}) => {
    switch(action.type) {
        case SET_SUBJECTS:
            return {
                ...state,
                data: action.isAddMode
                    ? state.data.filter(subjectSet => !action.subjects.find(subjectToAdd => subjectToAdd._id === subjectSet._id)).concat(action.subjects)
                    : action.subjects,
                isFetching: false,
            };

        case SET_PAGES:
            return {
                ...state,
                data: state.data.map(subject => {
                    if(subject._id === action.subjectId) {
                        return {
                            ...subject,
                            pages: action.pages.filter(page => page.subject === subject._id),
                        };
                    }
                    return subject;
                }),
            };

        case SET_QUESTIONS:
            return {
                ...state,
                data: state.data.map(subject => {
                    if(subject._id === action.subjectId) {
                        return {
                            ...subject,
                            questions: action.questions.filter(question => question.subject === subject._id),
                        };
                    }
                    return subject;
                }),
            };

        case SET_IS_FETCHING:
            if(action.dataType === 'subjects') {
                return {
                    ...state,
                    isFetching: action.isFetching,
                };
            }
            return state;

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
};

export default SubjectReducer;
